import { tippy, TippyProps } from '@tippyjs/react';
import { Editor, Range } from '@tiptap/core';
import { EditorState } from '@tiptap/pm/state';
import { ReactRenderer } from '@tiptap/react';
import { SuggestionOptions, SuggestionProps } from '@tiptap/suggestion';
import { IconType } from 'copilot-design-system';
import React from 'react';

export type Suggestion = {
  title: string;
  icon?: IconType;
  command: SuggestionOptions['command'];
};
type Component = {
  element: Element;
  updateProps: (props: SuggestionProps<SlashMenuRendererProps>) => void;
  destroy: () => void;
};
export type SlashMenuRendererProps = {
  items: Suggestion[];
  command: ({
    editor,
    range,
  }: {
    editor: Editor;
    range: Range;
    props: SlashMenuRendererProps;
  }) => void;
};

export const SlashMenuRenderer = ({
  Component,
  ComponentProps,
  tippyProps,
  shouldShow,
}: {
  Component: React.ComponentType<any>;
  ComponentProps?: Record<string, any>;
  tippyProps?: Partial<TippyProps>;
  shouldShow?: ({ state }: { state: EditorState }) => boolean;
}) => {
  let component: Component;
  let popup: any[] = [];
  return {
    onStart: (props: SuggestionProps<SlashMenuRendererProps>) => {
      component = new ReactRenderer(Component, {
        props: {
          ...ComponentProps,
          ...props,
        },
        editor: props.editor,
      });

      // @ts-ignore
      popup = tippy('body', {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: component.element,
        showOnCreate:
          shouldShow !== undefined
            ? shouldShow({ state: props.editor.state })
            : true,
        interactive: true,
        trigger: 'manual',
        maxWidth: 'auto',
        ...tippyProps,
      });
    },
    onUpdate: (props: SuggestionProps<SlashMenuRendererProps>) => {
      component.updateProps(props);
      popup.at(0)?.setProps({
        getReferenceClientRect: props.clientRect,
      });
      if (shouldShow !== undefined) {
        if (shouldShow({ state: props.editor.state })) {
          popup.at(0)?.show();
        } else {
          popup.at(0)?.hide();
        }
      } else {
        popup.at(0)?.show();
      }
    },
    onExit() {
      popup.at(0)?.destroy();
      component.destroy();
    },
  };
};
